import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from '@my-services/auth.service';
import { Router } from '@angular/router';
import { Constants } from '@my-util/constants';
import { ToastrService } from 'ngx-toastr';
import Utility from '@my-util/utility';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authservice: AuthService,private router: Router,  private toastr: ToastrService) {}
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError(err => {
      if ([401, 403].includes(err.status)) {
          this.authservice.logoutUnauthorized();
          this.router.navigate([Constants.LOGIN_ROUTE]);
      }
      else if ([0].includes(err.status)) {
        if (navigator.onLine) {
          this.toastr.error(`${Utility.serverErrorMsg} ${err.status}`, `Error`);
        }
        else{
          this.toastr.warning(`You are offline`, `Warning!`);
        }
      }
      const error = err;
      return throwError(()=> error);
  }))
  }
}
